export default __webpack_public_path__ + "424522c4cd15ceef7c6b643303f018ba.png";